import { Input } from 'antd';
import PropTypes from 'prop-types';
import ReactInputMask from 'react-input-mask';

import FormField from '../form-field/form-field';
import { phoneNumberFormatter } from '../../../utils/formatters';

const PhoneFormField = ({
  formik,
  form,
  name,
  label,
  placeholder,
  ...props
}) => {
  const handlePaste = (evt) => {
    const digits = (evt.clipboardData?.getData('text') || '').replace(/\D/g, '');

    evt.preventDefault();

    const phone = digits.length > 10 ? digits.slice(1, 11) : digits;

    formik.setFieldValue(name, phone);
    form.setFieldsValue({ [name]: phone });
  };

  return (
    <FormField
      formik={formik}
      name={name}
      label={label}
      placeholder={placeholder}
      component={ReactInputMask}
      mask="+7\-(999)-999-99-99"
      maskChar="X"
      onChange={(evt) => formik.setFieldValue(
        name,
        phoneNumberFormatter(evt.target.value),
      )}
      onPaste={handlePaste}
      {...props}
    >
      {(inputProps) => <Input {...inputProps} />}
    </FormField>
  );
};

PhoneFormField.propTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func.isRequired,
  }).isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

PhoneFormField.defaultProps = {
  name: 'phone',
  label: 'Номер телефона',
  placeholder: 'Введите номер телефона',
};

export default PhoneFormField;
